export default "/react/logoAiCapPredict-478bbd9a.png";